import { Component, Input, OnInit } from '@angular/core'
import { LogEvent } from 'src/app/interfaces/log'
import { LogService } from 'src/app/services/log/log.service'
import { NotificationService } from 'src/app/services/notification/notification.service'
import { RouterService } from 'src/app/services/router/router.service'
import { UserService } from 'src/app/services/user/user.service'

@Component({
  selector: 'main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent implements OnInit {
  constructor(
    private userService: UserService,
    private notificationService: NotificationService,
    private logService: LogService,
    private routerService: RouterService
  ) {}

  private latestNotificationId = 0

  get hasNewNotification(): boolean {
    return this.latestNotificationId > this.notificationService.latestReadNotificationId
  }

  @Input() showLoginButton = true

  ngOnInit() {
    if (!this.userService.isLoggedIn) {
      return
    }
    this.notificationService.getNotificationList().subscribe((res) => {
      const data = res.data ?? []
      if (data.length > 0) {
        this.latestNotificationId = data[0].id
      }
    })
  }

  onClickLogo(): void {
    this.logService.eventLogging(LogEvent.HEADER_LOGO_CLICKED, { from: location.pathname })
    this.routerService.navigate('gnb/main')
  }

  onClickAlarm(): void {
    this.routerService.navigate('alarm')
    this.logService.eventLogging(LogEvent.HOME_NOTIFICATION_CLICKED, { screenName: 'home' })
  }
}
